import {
  ApplicationRef,
  createComponent,
  EmbeddedViewRef,
  EnvironmentInjector,
  Injectable,
  Type,
} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TableCellRendererService {
  constructor(
    private appRef: ApplicationRef,
    private envInjector: EnvironmentInjector,
  ) {}

  /** Create a dynamic component and attach it to the DOM */
  createRenderer<T extends object>(
    component: Type<T>,
    data?: Partial<T>,
  ): HTMLElement {
    const ref = createComponent(component, {
      environmentInjector: this.envInjector,
    });

    // Does not current support signals (additional work is needed if required).
    if (data) Object.assign(ref.instance, data);

    ref.changeDetectorRef.detectChanges();

    this.appRef.attachView(ref.hostView);

    const node = (ref.hostView as EmbeddedViewRef<any>).rootNodes[0];

    document.body.appendChild(node);

    return node;
    // Had seen a comment that we might lose the element if we dont return ref, but removed it to reduce boilerplate.
    // If there is issues it might need to be added back.
    // return { node, ref };
  }
}
